import React from 'react';
import {getAppIntentUrlForDevices} from '../../../features/AppRedirect/helpers';
import type {DEVICE_PARAM_TYPE} from '../../../features/Checkout/constants';

export class PayOrderAppAppLinksProxyError extends Error {
  constructor({message, status}: {message: string; status: number}) {
    super(message);
    this.name = 'PayOrderAppAppLinksProxyError';
    this.status = status;
  }

  status: number;
}

export const AppLinksErrorUI: React.FC<{
  orderId?: string;
  device?: DEVICE_PARAM_TYPE;
}> = ({orderId, device = 'android'}) => {
  const backUrl = getAppIntentUrlForDevices({
    device,
    searchParams: '',
    intent: orderId ? `a/order/${orderId}` : `a/orders`,
  });

  return (
    <html>
      <head>
        <title>Authentication</title>
        <meta charSet="UTF-8"></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        {style}
      </head>
      <body>
        <div className="button-container">
          <a className="button" id="retry-button">
            Retry
          </a>
          <script
            dangerouslySetInnerHTML={{
              __html: `
                document.getElementById('retry-button').addEventListener('click', function() {
                  window.location.reload();
                });
              `,
            }}
          />
          <a className="button button-secondary" href={backUrl!}>
            Back
          </a>
        </div>
      </body>
    </html>
  );
};

const style = (
  <style>
    {`
body {
    margin: 0;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-family: Inter, sans-serif;
    text-align: center;
    height: 75vh;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    margin-top: 24px;
  }

  .button {
    display: inline-block;
    padding: 12px 24px;
    border-radius: 4px;
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    background-color: #000;
    color: #fff;
    min-width: 160px;
    text-align: center;
  }

  .button-secondary {
    background-color: #fff;
    color: #000;
    border: 2px solid #000;
  }
`}
  </style>
);
